import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon3D = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7662 21.4009L20.3703 16.4229C20.8891 16.0832 21.2007 15.5055 21.2007 14.8855L21.2007 8.63816C21.2007 8.01779 20.8878 7.43926 20.3685 7.09971L12.7675 2.12889C12.1561 1.72908 11.366 1.72921 10.7548 2.12922L3.15976 7.09965C2.64083 7.43925 2.32812 8.01621 2.32812 8.63638V14.8911C2.32812 15.5111 2.64067 16.0871 3.15939 16.4267L10.7542 21.3996C11.3658 21.8 12.1546 21.8013 12.7662 21.4009Z",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.08594 8.08789L11.7835 13.5323L20.733 8.08789",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7852 13.5293V21.0815",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIcon3D;
